import { RouteRef } from '@backstage/core-plugin-api';

import { createPageRoute } from '@spotify/confidence-core-react';

export enum RoutesIds {
  userSettings = 'user-settings',
}

export const userSettingsRouteRef = createPageRoute({
  id: 'user-settings',
  page: { title: 'Settings' },
});

export const rootRouteRef = userSettingsRouteRef;

export const Routes = {
  [RoutesIds.userSettings]: userSettingsRouteRef,
} satisfies Record<RoutesIds, RouteRef>;
